var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getCookie, getXsrf } from './utils';
import { Result } from '@tencent/tdoc-database';
import { HttpError } from '@tencent/tdoc-database';
import Log from './Log';
import { TOC_ORIGIN } from '../config';
/*
 * @Author: freedeng
 * @Date: 2019-06-13 20:16:26
 * @Last Modified by: paddywu
 * @Last Modified time: 2019-11-28 11:20:16
 */
var Method;
(function (Method) {
    Method["POST"] = "POST";
    Method["GET"] = "GET";
})(Method || (Method = {}));
export var PadInfoKey;
(function (PadInfoKey) {
    PadInfoKey[PadInfoKey["privilegeAttribute"] = 1] = "privilegeAttribute";
    PadInfoKey[PadInfoKey["title"] = 2] = "title";
})(PadInfoKey || (PadInfoKey = {}));
var CGI = /** @class */ (function () {
    function CGI() {
    }
    CGI.transferHide2Normal = function (secretId) {
        return __awaiter(this, void 0, void 0, function () {
            var queryString, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryString = '/cgi-bin/online_docs/doc_transferhidetonormal';
                        body = "'encrypted_doc_id=" + secretId;
                        return [4 /*yield*/, this.sendCommonRequest(queryString, Method.POST, body)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CGI.notifyOpenDoc = function (secretId) {
        return __awaiter(this, void 0, void 0, function () {
            var queryString, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryString = '/cgi-bin/online_docs/doc_broselistadd?t=1';
                        body = "'encrypted_doc_id=" + secretId;
                        return [4 /*yield*/, this.sendCommonRequest(queryString, Method.POST, body)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CGI.fetchDocDataSlide = function (secretId, outformat) {
        if (outformat === void 0) { outformat = false; }
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = TOC_ORIGIN + "/dop-api/slide/data/get?id=" + secretId + "&normal=1&prefetch=1&offline=1";
                        return [4 /*yield*/, this.sendCommonRequest(url, Method.GET, '', outformat ? undefined : 'custom')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CGI.fetchDocData = function (secretId, queryString, prefetch, outformat) {
        if (prefetch === void 0) { prefetch = true; }
        if (outformat === void 0) { outformat = false; }
        return __awaiter(this, void 0, void 0, function () {
            var key, keyValue, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (queryString && queryString.indexOf('?') > -1) {
                            // queryString += '&';
                        }
                        else {
                            queryString += '?';
                        }
                        key = 'preview_token';
                        keyValue = getCookie(key);
                        url = "/dop-api/opendoc" + queryString + (prefetch && '&prefetch=1') + (outformat ? '&outformat=1' : '') + "&normal=1&id=" + secretId + "&key=" + keyValue + "&xsrf=" + getXsrf();
                        return [4 /*yield*/, this.sendCommonRequest(url, Method.GET, '', outformat ? undefined : 'custom')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *
     * @param secretId
     * @param infoKeys 1:权限信息 2:文档title
     */
    CGI.getPadInfo = function (secretId, infoKeys) {
        return __awaiter(this, void 0, void 0, function () {
            var extraInfo, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        extraInfo = infoKeys ? "&infoKeys=[" + infoKeys + "]" : '';
                        request = "/cgi-go/padinfo/getpadinfo?encodePadId=" + secretId + extraInfo + "&xsrf=" + getXsrf();
                        return [4 /*yield*/, this.sendCommonRequest(request, Method.GET)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *
     * @param queryString
     * @param method
     * @param body
     * @param responseType
     */
    CGI.sendCommonRequest = function (queryString, method, body, responseType) {
        if (method === void 0) { method = Method.GET; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        try {
                            var error_1;
                            var xhr_1 = new XMLHttpRequest();
                            xhr_1.onreadystatechange = function () {
                                if (xhr_1.readyState === XMLHttpRequest.DONE) {
                                    var data = '';
                                    if (xhr_1.status === 200) {
                                        try {
                                            if (responseType && responseType === 'custom') {
                                                data = xhr_1.responseText;
                                            }
                                            else {
                                                data = JSON.parse(xhr_1.responseText);
                                            }
                                        }
                                        catch (e) {
                                            Log.error("sendCommonRequest failed: query:" + queryString + ", responseText:" + xhr_1.responseText + " error:" + e);
                                            error_1 = e;
                                        }
                                    }
                                    else {
                                        error_1 = new HttpError(xhr_1.status, 0, 'StatusError');
                                    }
                                    resolve(new Result(error_1, data));
                                }
                            };
                            try {
                                xhr_1.timeout = 30000;
                            }
                            catch (e) { }
                            xhr_1.ontimeout = function () {
                                error_1 = new Error('TimeOutError');
                                resolve(new Result(error_1));
                            };
                            xhr_1.open(method, queryString);
                            xhr_1.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
                            xhr_1.send(body);
                        }
                        catch (error) {
                            resolve(new Result(error));
                        }
                    })];
            });
        });
    };
    return CGI;
}());
export { CGI, Method };
//# sourceMappingURL=CGI.js.map